import { render, staticRenderFns } from "./NewMatrixCourseName.vue?vue&type=template&id=0eb42ff0&"
import script from "./NewMatrixCourseName.vue?vue&type=script&lang=js&"
export * from "./NewMatrixCourseName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports